document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-grida-pdp]');
  if (!root) return;
/* ---------- Gallery ---------- */
const slides = root.querySelectorAll('.stage-slide');
const thumbs = root.querySelectorAll('.thumb');
const stageLabel = root.querySelector('#stageLabel');
const stageCounter = root.querySelector('#stageCounter');
let idx = 0;
function showSlide(i) {
  idx = (i + slides.length) % slides.length;
  slides.forEach((s, j) => s.classList.toggle('active', j === idx));
  thumbs.forEach((t, j) => t.classList.toggle('active', j === idx));
  stageLabel.textContent = slides[idx].dataset.label || '';
  stageCounter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
  if (window.innerWidth <= 900) {
    const t = thumbs[idx];
    if (t && t.parentElement) {
      t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
    }
  }
}
thumbs.forEach(t => t.addEventListener('click', () => showSlide(parseInt(t.dataset.i))));
root.querySelector('#stagePrev').addEventListener('click', () => showSlide(idx - 1));
root.querySelector('#stageNext').addEventListener('click', () => showSlide(idx + 1));

const stage = root.querySelector('#stage');
let tStartX = null;
stage.addEventListener('touchstart', e => { tStartX = e.touches[0].clientX; }, { passive: true });
stage.addEventListener('touchend', e => {
  if (tStartX == null) return;
  const dx = e.changedTouches[0].clientX - tStartX;
  if (Math.abs(dx) > 40) showSlide(idx + (dx < 0 ? 1 : -1));
  tStartX = null;
});


});
